const exported = {
    AUDIO: "audio",
    LIVE: "live",
};

export const { AUDIO, LIVE } = exported;
